import script from "./UserSetItemsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSetItemsList.vue?vue&type=script&setup=true&lang=ts"

import "./UserSetItemsList.vue?vue&type=style&index=0&id=51428d4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51428d4c"]])

export default __exports__